import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'sms4.settings.communication.notifications.delayedSettings' }),

    description: translate({
      id: 'sms4.settings.communication.notifications.delayedSettings.description',
    }),

    disableDescription: translate({
      id: 'sms4.settings.communication.notifications.delayedSettings.toggle.disable',
    }),

    enableDescription: translate({
      id: 'sms4.settings.communication.notifications.delayedSettings.toggle.enable',
    }),
  }))

  return api
}
